<template>
    <router-link
        class="post-wrapper"
        :to="getPositionURL"
        :class="{ promote: promote }"
    >
        <div class="post-root px-3 py-2 clickable">
            <div class="d-flex align-items-center">
                <div
                    class="image-wrapper d-flex flex-column justify-content-center"
                >
                    <img
                        v-if="image !== undefined"
                        class="image-default image-center image"
                        :src="image"
                        :alt="title"
                    />
                </div>
                <div class="ml-3 d-flex flex-column justify-content-center">
                    <h5 class="subtitle" style="font-size: 18px;">
                        {{ title }}
                    </h5>
                    <!-- <p class="caption mute mb-1" style="font-size: 10px;">{{ position }}</p> -->
                    <p class="caption mute mb-1" style="font-size: 14px;">
                        {{ companyName }}
                        {{ country || location ? '|' : '' }}
                        {{ country }}
                        {{
                            country && location
                                ? ', '.concat(location)
                                : location
                        }}
                    </p>
                    <p class="caption mute mb-1" style="font-size: 14px;">
                        {{ $t('shared.postingModule.postItem.applyBefore') }}
                        {{ deadlineTime }}
                    </p>
                </div>
            </div>
            <!-- <div class="flex-grow" /> -->
            <div class="label-grid">
                <div v-for="(item, index) in labels" :key="index">
                    <b-img
                        v-if="item.type === 'img'"
                        v-b-tooltip.hover
                        rounded
                        :alt="item.text"
                        :src="item.img"
                        :title="item.tooltip"
                        height="60"
                    />
                    <b-badge
                        v-else
                        v-b-tooltip.hover
                        class="subtitle px-3 m-1"
                        :title="item.tooltip"
                        style="color: var(--secondary); border: 1px solid var(--secondary); background-color: white; display: block; white-space: nowrap;"
                    >
                        {{ item.text }}
                    </b-badge>
                </div>
            </div>
        </div>
        <Divider />
    </router-link>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import moment from 'moment';
import dateToString from '~/utils/dateToString';

export default {
    name: 'PostItem',
    props: {
        id: {
            type: String,
            required: true,
        },
        image: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        position: String,
        companyName: String,
        location: String,
        country: String,
        deadline: String,
        RequestId: String,
        EventId: String,
        labels: Array,
        promote: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        deadlineTime: function() {
            this.$interfaces.localeModule.getLocaleItem(); // This is for updating deadline-string when locale changes
            return dateToString(this.$props.deadline);
        },
        getPositionURL: function() {
            const url = this.$URLS.jobDetail.concat(
                '/',
                this.$props.id.toString(),
                this.RequestId && this.EventId
                    ? `?RequestId=${this.RequestId}&EventId=${this.EventId}`
                    : ''
            );
            return url;
        },
    },
};
</script>

<style scoped>
.post-wrapper {
    position: relative;
    overflow: hidden;
    /*  display: inline-block; */
    text-decoration: none;
}
.post-root {
    width: '100%';
    min-height: 145px;
    display: flex;
    align-items: center;
}
.label-grid {
    display: flex;
    flex-wrap: wrap;
    max-width: 200px;
    flex-shrink: 0;
    justify-content: flex-end;
    align-content: center;
    margin-left: auto;
}

@media only screen and (max-width: 600px) {
    .post-root {
        /* display: grid;
        grid-template: */
        flex-wrap: wrap;
    }
    .label-grid {
        justify-self: center;
        justify-content: center;
        max-width: 100%;
        margin: 0 auto;
    }
}

.image {
    max-width: 90px;
}
.image-wrapper {
    /* margin: 0 10px 0 0; */
    min-width: 90px;
    width: 90px;
    max-width: 90px;
    overflow: hidden;
    height: 120px;
}

.promote::before {
    position: absolute;
    content: '';
    left: 10px;
    top: 10px;
    cursor: pointer;

    background-color: var(--secondary); /*Good yellow: #fde18c */
    mask-repeat: space;
    -webkit-mask-image: url('../../assets/img/star.svg');
    mask-image: url('../../assets/img/star.svg');

    opacity: 0.5;

    height: 10px;
    width: 10px;
}
</style>
